// Encompass encodes co-borrower scope in the title; Ello persists that scope
// separately on the Condition.
export const CO_BORROWER_CONDITION_TITLE_PREFIX = 'CoBorrower | '

function getTitleWithoutCoBorrowerPrefix(title: string): string | null {
  const trimmedTitle = title.trimStart()
  const prefix = CO_BORROWER_CONDITION_TITLE_PREFIX.trimEnd()

  if (!trimmedTitle.toLowerCase().startsWith(prefix.toLowerCase())) {
    return null
  }

  return trimmedTitle.slice(prefix.length).trimStart()
}

function getTitleWithoutCoBorrowerPrefixes(title: string): string | null {
  let normalizedTitle = getTitleWithoutCoBorrowerPrefix(title)
  if (normalizedTitle == null) return null

  let titleWithoutPrefix = getTitleWithoutCoBorrowerPrefix(normalizedTitle)
  while (titleWithoutPrefix != null) {
    normalizedTitle = titleWithoutPrefix
    titleWithoutPrefix = getTitleWithoutCoBorrowerPrefix(normalizedTitle)
  }

  return normalizedTitle
}

export function hasReservedCoBorrowerConditionTitlePrefix(
  title: string | null | undefined
): boolean {
  return getTitleWithoutCoBorrowerPrefix(title ?? '') != null
}

export function getEncompassConditionTitle({
  title,
  isCoBorrower,
}: {
  title: string
  isCoBorrower: boolean
}): string {
  if (!isCoBorrower) return title

  const businessTitle = getTitleWithoutCoBorrowerPrefixes(title) ?? title
  return `${CO_BORROWER_CONDITION_TITLE_PREFIX}${businessTitle}`
}

export function getElloConditionTitle({
  title,
  isCoBorrower,
}: {
  title: string
  isCoBorrower: boolean
}): string {
  if (!isCoBorrower) return title

  return getTitleWithoutCoBorrowerPrefixes(title) ?? title
}
